<template lang="pug">
.card
    .rounded-top
        img.img-fluid.card-img-top.py-3.rounded-circle( :src='contentData.imgSrc' )
    .card-body.text-center.d-flex.justify-content-around
        .row
            .col-12
                p.card-text.text-secondary
                    a.play-btn.image-btn( @click="show()" data-toggle='modal', :data-src='contentData.toShow', data-target='#modal', style='text-decoration: underline;')
                      i.fa.fa-3x(:class='contentData.fontAwesomeIcon')
                      br 
                      template {{ contentData.axnText }}
            .col-12
                span.card-title.text-primary {{ contentData.personName }}
                    
</template>

<script>
export default {
    props: { 
        contentData: { type: Object, required: true } 
    },
    methods:{
        show () {
            this.$bus.$emit('show', {
                url: this.contentData.toShow,
                type: this.contentData.typeToShow
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/landing/testimonials/TeCard.vue